import _Vue from 'vue'

import store from '@/store'

const Translate = {
  install(Vue: typeof _Vue) {
    Vue.mixin({
      methods: {
        translate(key: string, plural = false): string {
          return store.getters.translation(key, plural)
        },
      },
    })
  },
}

export default Translate
